export { default } from './ApiSettings'
